module.exports = __webpack_public_path__ + "media/Images/icon-piggy-bank-o-7b8ae5ee246f00f0ef8397396a26b11a.svg";